var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.location)?_c('div',{staticClass:"has-text-centered navbar-item"},[_c('BaseIcon',{attrs:{"icon":"locationMarker","size":_vm.iconSize,"classNames":{'store-navigation-color': true}}}),_vm._v(" "),_c('a',{attrs:{"id":"location-header"}},[_vm._v(_vm._s(this.location.address))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1148b30","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/CurrentLocation.vue
// module id = null
// module chunks = 